<template>
  <div>
    <v-card
      flat
      height="76px"
      class="d-flex align-center text-center"
      :class="[
        $vuetify.theme.dark ? 'border-dark' : 'border-light',
        getStatusColor(
          deadlineEntry.status,
          $vuetify.theme.dark ? 'dark' : 'light',
          'background'
        ),
      ]"
      @click="toggleResponseDetailDialog"
    >
      <v-card-text>
        <v-icon
          :color="
            getStatusColor(
              deadlineEntry.status,
              $vuetify.theme.dark ? 'dark' : 'light',
              'text'
            )
          "
        ></v-icon>

        <span
          v-if="deadlineEntry.dueDate"
          class="subtitle-2 font-weight-medium black--text"
          >{{ timestampConverter(deadlineEntry.dueDate) }}</span
        >

        <v-card v-if="deadlineEntry.pendingUpdate?.newDueDate" dense outlined>
          <small>Wartet auf Genehmigung</small>
          <v-divider></v-divider>
          <span
            v-if="deadlineEntry.pendingUpdate?.newDueDate"
            class="subtitle-2 font-weight-medium black--text"
            >{{
              timestampConverter(deadlineEntry.pendingUpdate?.newDueDate)
            }}</span
          >
        </v-card>

        <div v-if="deadlineEntry.labels">
          <v-chip
            small
            outlined
            v-for="(label, index) in deadlineEntry.labels"
            :key="index"
            :light="$vuetify.theme.dark"
            class="py-0 my-1 mr-1"
          >
            {{ label }}</v-chip
          >
        </div>
      </v-card-text>
    </v-card>
    <CustomDialog
      v-if="showResponseDetailDialog"
      @close="toggleResponseDetailDialog()"
      title="Fristeneintrag"
      fullscreenOnMobile
      width="s"
      showCloseBtn
      hideCloseBtn
      hideActionBtn
    >
      <template v-slot:content>
        <v-card outlined>
          <v-card-text v-if="!deadlineEntry.status">
            Kein Fristeneintrag vorhanden</v-card-text
          >
          <deadline-entry-list-item
            v-else
            :deadlineEntry="deadlineEntry"
          ></deadline-entry-list-item></v-card
      ></template>
    </CustomDialog>
  </div>
</template>

<script>
import CustomDialog from "@/components/_systemwide/CustomDialog.vue";
import DeadlineEntryListItem from "@/components/member-management/deadlines/DeadlineEntryListItem.vue";
export default {
  name: "teamplanner-deadlineEntry-status-card",
  components: { CustomDialog, DeadlineEntryListItem },
  props: {
    deadlineEntry: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      showResponseDetailDialog: false,
    };
  },
  methods: {
    toggleResponseDetailDialog() {
      this.showResponseDetailDialog = !this.showResponseDetailDialog;
    },

    getStatusColor(status, theme = "light", colorScheme = "background") {
      if (colorScheme === "background") {
        switch (status) {
          case "-1":
            return theme === "dark" ? "purple lighten-4" : "purple lighten-4";
          case "0":
          case "Unknown":
            return "blue-grey lighten-2";
          case "1":
          case "valid":
            return theme === "dark" ? "green lighten-4" : "green lighten-4";
          case "expired":
            return theme === "dark" ? "red lighten-4" : "red lighten-4";
          case "3":
          case "soonDue":
            return theme === "dark" ? "orange lighten-4" : "orange lighten-4";
          case "":
          default:
            return "blue-grey lighten-2";
        }
      } else {
        switch (status) {
          case "-1":
            return theme === "dark" ? "purple darken-2" : "purple darken-2";
          case "0":
          case "Unknown":
            return "blue-grey darken-2";
          case "valid":
            return theme === "dark" ? "green darken-2" : "green darken-2";
          case "expired":
            return theme === "dark" ? "red darken-2" : "red darken-2";
          case "soonDue":
            return theme === "dark" ? "orange darken-2" : "orange darken-2";
          case "":
          default:
            return "blue-grey darken-2";
        }
      }
    },
    getStatusIcon(status) {
      switch (status) {
        case "-1":
          return "mdi-cancel";
        case "0":
        case "Unknown":
          return "mdi-help-circle";
        case "1":
        case "yes":
          return "mdi-check-circle";
        case "2":
        case "no":
          return "mdi-close-circle";
        case "3":
        case "maybe":
          return "mdi-minus-circle";
        case "4":
        case "away":
          return "mdi-airplane";
        case "":
        default:
          return "mdi-alert-outline";
      }
    },
    timestampConverter(timestamp) {
      if (!timestamp) return "";
      const options = {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      };
      return timestamp.toDate().toLocaleDateString("de-DE", options);
    },
  },
};
</script>

<style>
.border-light {
  border: thin solid rgba(0, 0, 0, 0.12) !important;
}

.border-light.lighten-4 {
  border: thin solid rgba(0, 0, 0, 0.12) !important;
}

.border-dark {
  border: thin solid hsla(0, 0%, 100%, 0.12) !important;
}

.border-dark.lighten-4 {
  border: thin solid hsla(0, 0%, 100%, 0.12) !important;
}
</style>
